import { toast } from "sonner";

export default function useToast() {
  return {
    showSuccessToast: (message) => toast.success(message),
    showErrorToast: (message) => toast.error(message),
    showInfoToast: (message) => toast(message)
  };
}
